import { getAuthToken } from '../hooks/useAuth';

interface FeedbackPayload {
  feedback_type: 'positive' | 'negative' | 'free_form';
  session_id: string;
  prompt?: string;
  feedback_text?: string;
}

/**
 * Fire-and-forget feedback via the /invocations endpoint.
 *
 * AgentCore only proxies /invocations, so we send feedback as a regular
 * invocation with a "feedback" field. The backend detects this and
 * short-circuits before running the agent.
 *
 * Errors are logged to console only -- never blocks the chat UX.
 */
export function submitFeedback(payload: FeedbackPayload): void {
  try {
    const endpoint =
      import.meta.env.VITE_AGENTCORE_ENDPOINT || 'http://localhost:8080/invocations';

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      'X-Amzn-Bedrock-AgentCore-Runtime-Session-Id': `feedback_${Date.now()}_${Math.random().toString(36).substr(2, 12)}`,
    };
    const token = getAuthToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    fetch(endpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify({ feedback: payload }),
    }).catch((err) => {
      console.error('Failed to submit feedback:', err);
    });
  } catch (err) {
    console.error('Failed to submit feedback:', err);
  }
}
